// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"194":"7dbdcc0a","2122":"7dbdcc0a","8270":"7dbdcc0a","8626":"7dbdcc0a","9885":"7dbdcc0a"}[chunkId] + ".chunk.css";
};